import { connect } from 'react-redux';
import { Dispatch } from 'react';
import { ITutorialEvents } from '../../components/Tutorial/types';
import { Tutorial } from '../../components/Tutorial/Tutorial';
import { onFinish } from './events/onFinish';
import { onPlay } from './events/onPlay';

const mapDispatchToProps = (
    dispatch: Dispatch<any>,
): ITutorialEvents => {
    return {
        onPlay: (key) => dispatch(onPlay(key)),
        onFinish: (key) => dispatch(onFinish(key)),
    };
};

export const TutorialHOC = connect(
    null,
    mapDispatchToProps,
)(Tutorial);

TutorialHOC.displayName = 'TutorialHOC';
